import React from "react";
import {
  Button,
  Card,
  Grid,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import numeral from "numeral";

const BookingConfirm = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [, setAlert] = React.useState({ show: false, message: "" });
  const [booking] = React.useState({
    amount: props.total,
    remarks: "GuestHouse Bookings",
  });

  const _makeRequest = async () => {
    try {
      setLoading(true);
      setAlert({ show: false, message: "" });
      setLoading(false);
      props.onSuccess({ reference: "loanTxRef" },props.paymentMode,props.total);
      
      props.toggleModal(false);
    } catch (error) {
      setLoading(false);
      setAlert({ show: true, message: "Transaction failed" });

      console.log("error", error);
    }
  };

  return (
    <div>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}

      <Grid centered style={{ marginTop: 10, marginBottom: 10 }}>
        <Card centered>
          <Card.Content>
            <Card.Meta>Confirm Book On Hold</Card.Meta>
          </Card.Content>
          <Card.Content>
            <Grid columns={2} textAlign="left">
              <Grid.Row>
                <Grid.Column>Request Amount</Grid.Column>
                <Grid.Column>
                  <b>
                    ₦{numeral(booking.amount).format("0,0")}
                  </b>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
          <Card.Content>
            <Button positive onClick={_makeRequest} style={{ width: "100%" }}>
              Confirm Request
            </Button>
          </Card.Content>
        </Card>
      </Grid>
    </div>
  );
};

export default BookingConfirm;
